export interface ScacBookingEligibleResponse {
  eligibleToBookLoad: boolean;
  errors: string[];
  lineHaulRate: number;
  contractedRate: number;
  breakevenRate: number;
  loadshopFee: number;
  fuelRate: number;
}
